import UploadImagesModal from "./UploadImagesModal";

export default UploadImagesModal;
